import { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  cleanFilterData,
  buildQueryParams,
} from "../../../../../Utils/FilterUtils";
import httpclient from "../../../../../Utils";

export const useBreakReport = ({ autoFetch = true, filters = {} } = {}) => {
  const [reportData, setReportData] = useState([]);
  const [pickers, setPickers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });

  const fieldMappings = {
    picker_id: ["picker_id"],
    start_date: ["start_date"],
    end_date: ["end_date"],
    page: ["page"],
    pagination: ["pagination"],
  };

  const valueTransformers = {
    start_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
    end_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
  };

  const fetchReportData = async (filterData = {}) => {
    setLoading(true);
    setError(null);

    const dataWithPagination = {
      ...filterData,
      page: pagination.page,
      pagination: pagination.pageSize,
    };
    const cleanedData = cleanFilterData(dataWithPagination);
    const queryParams = buildQueryParams(
      cleanedData,
      fieldMappings,
      {},
      valueTransformers
    );
    const url = `/reports/break-report${queryParams ? `?${queryParams}` : ""}`;

    try {
      const response = await httpclient.get(url);
      if (response.data.status === 200) {
        setReportData(response.data.data || []);
        setPickers(response.data.pickers || []);
        setPagination((prev) => ({
          ...prev,
          total: response.data.meta?.total || 0,
        }));
      } else {
        setError(response.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchReportData();
    }
  }, [autoFetch]);

  return {
    reportData,
    pickers,
    loading,
    error,
    pagination,
    setPagination,
    fetchReportData,
  };
};
